import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import {
 PnrDetails
} from '../model';
import { ModelOptions } from '../../../types';

export interface Context<T> {
    get: (params?: Partial<T>, options?: ModelOptions, updateState?: boolean) => Promise<Array<T>>;
    getOne: (params: Partial<T>, body?: { populateQuery?: Array<any> }, updateState?: boolean) => Promise<T>;
    post: (body: Partial<T>, updateState?: boolean, last?: boolean) => Promise<T>;
    put: (body: Partial<T>, updateState?: boolean) => Promise<T>;
    remove?: (id: string) => Promise<string>;
    softDelete: (body: { _id: string }) => Promise<any>;
    data: T[];
    setData: (array: Array<T>) => void;
    selected: T | null;
    setSelected: (object: T) => void;
    error?: T | null | {};
}
export interface SuggestedPnr {
    pnrNumber: string;
    matched_passengers: number;
    total_passengers: number;
    matched_passenger_names: string | null;
    all_passenger_names: string | null;
    currency: string | null;
    total_amount: string | number | null;
    from_iata: string | null;
    to_iata: string | null;
    departure_date: string | null;
}

export interface PnrSearchResult {
    pnrNumber: string;
    passenger_count: number;
    total_amount: string | number | null;
    currency: string | null;
    sample_passengers: string | null;
    last_updated: string | null;
    created_at: string | null;
    from_iata: string | null;
    to_iata: string | null;
    departure_date: string | null;
    // Optional, populated when rows come from `getSuggestedPnrsByTravelFile` so
    // the grid can show "matched/total" + a tooltip with all passenger names.
    matched_passengers?: number | null;
    total_passengers?: number | null;
    matched_passenger_names?: string | null;
    all_passenger_names?: string | null;
}

export interface PnrSearchFilters {
    departureDate?: string | null;
    createdDate?: string | null;
    travelFileId?: string | number | null;
}

export interface ExtendedContext extends Context<PnrDetails> {
    getFlightDetailsByPnrDetails: (query: any) => Promise<Array<PnrDetails>>;
    getSuggestedPnrsByTravelFile: (travelFileId: string | number) => Promise<Array<SuggestedPnr>>;
    searchPnrs: (q: string, filters?: PnrSearchFilters) => Promise<Array<PnrSearchResult>>;
    resetIsNewDataByPnrNumber: (query: any) => Promise<Array<PnrDetails>>;
}

export default createContext<ExtendedContext>({
    get: api.get,
    getOne: api.getOne,
    post: api.post,
    put: api.put,
    remove: api.remove,
    softDelete: api.softDelete,
    data: [],
    setData: noop,
    selected: null,
    setSelected: noop,
    error: null,
    getFlightDetailsByPnrDetails: api.getFlightDetailsByPnrDetails,
    getSuggestedPnrsByTravelFile: api.getSuggestedPnrsByTravelFile,
    searchPnrs: api.searchPnrs,
    resetIsNewDataByPnrNumber: api.resetIsNewDataByPnrNumber
});
